import { render } from "./FeatureCarousel.vue?vue&type=template&id=f7b37998"
import script from "./FeatureCarousel.vue?vue&type=script&lang=js"
export * from "./FeatureCarousel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__